import { Injectable, Type } from '@angular/core';
import { HisDynamicFieldType } from '../model/formfield';
import { InputNotImplementedComponent } from '../component/input-controls/input-not-implemented.component';

/**
 * The component registry manages the mapping of HisDynamicFieldTypes to Angular components.
 *
 * Non standard components can be added via the <code>register</code> method.
 */
@Injectable({providedIn: 'root'})
export class HisComponentRegistryService {
    private registry: Map<HisDynamicFieldType, Type<any>> = new Map();

    /**
     * returns a reference to the Angular component class which handles
     * the requested field type.
     *
     * @param hisDynamicFieldType HisDynamicFieldType to handle
     */
    public getComponentClass( hisDynamicFieldType: HisDynamicFieldType ): Type<any> {
        let component = this.registry.get( hisDynamicFieldType );

        if ( !component ) {
            component = InputNotImplementedComponent;
        }
        return component;
    }

    /**
     * registers a component for use in dynamic forms.
     *
     * @param hisDynamicFieldType HisDynamicFieldType to handle
     * @param component Angular component
     */
    public register( hisDynamicFieldType: HisDynamicFieldType, component: Type<any> ) {
        this.registry.set( hisDynamicFieldType, component );
    }

}
